// extracted by mini-css-extract-plugin
export default {"button":"learningStatus_button__EHuh-","buttonLearned":"learningStatus_buttonLearned__iKvWT","buttonLink":"learningStatus_buttonLink__fTrF8","badge":"learningStatus_badge__5VEam"};